var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLivingWageFoundationLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 194.257,
    height: 153.309,
    viewBox: "0 0 194.257 153.309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_319",
    "data-name": "Rectangle 319",
    width: 194.257,
    height: 153.309,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1626",
    "data-name": "Group 1626",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    d: "M202.906,63.74a42.444,42.444,0,0,0-4.626.252,76.9,76.9,0,0,1-.854,60.038,23.359,23.359,0,0,1,10.448,23.428,42.006,42.006,0,0,0-4.968-83.717",
    transform: "translate(-50.652 -16.353)",
    fill: "#ffda19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M76.654,0a76.654,76.654,0,1,0,39.588,142.309,23.366,23.366,0,0,1,.486-30.494,42.016,42.016,0,0,1,30.9-64.176A76.68,76.68,0,0,0,76.654,0",
    fill: "#20c4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M185.675,64.079a42.015,42.015,0,0,0-30.9,64.176,23.379,23.379,0,0,1,30.044-4.138,76.9,76.9,0,0,0,.854-60.038",
    transform: "translate(-38.048 -16.44)",
    fill: "#20a818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M174.3,171.258a77.018,77.018,0,0,1-17.938,14.989,23.258,23.258,0,0,0,14.032,8.063,23.331,23.331,0,0,0,26.923-19.129c.008-.046.015-.092.023-.138a42.465,42.465,0,0,1-4.967.29,41.839,41.839,0,0,1-18.074-4.076",
    transform: "translate(-40.116 -43.939)",
    fill: "#f7942d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M193.079,144.836a76.731,76.731,0,0,1-12.592,19.643,41.849,41.849,0,0,0,18.073,4.076,42.639,42.639,0,0,0,4.968-.29,23.36,23.36,0,0,0-10.448-23.429",
    transform: "translate(-46.307 -37.16)",
    fill: "#f77f03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M154.973,150.4a23.363,23.363,0,0,0-.486,30.494,77.035,77.035,0,0,0,17.938-14.99,42.186,42.186,0,0,1-17.451-15.5",
    transform: "translate(-38.244 -38.588)",
    fill: "#1f721d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M174.428,139.876a23.368,23.368,0,0,0-17.416,7.825,42.193,42.193,0,0,0,17.451,15.505,76.731,76.731,0,0,0,12.592-19.643,23.493,23.493,0,0,0-12.628-3.687",
    transform: "translate(-40.284 -35.887)",
    fill: "#1f6203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M22.84,74.927h3.323l5.1-21.978H27.495l.8-3.589H39.9l-.842,3.589H35.293L30.152,74.971h9.085l1.019-4.3h3.855l-1.816,7.844H22Z",
    transform: "translate(-5.644 -12.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M53.435,75.551a9.146,9.146,0,0,1,.311-2.081L56.4,63.279H52.815L53.657,60h7.489L57.6,73.514a7.565,7.565,0,0,0-.311,1.95c0,.842.443,1.33,1.152,1.33.885,0,1.685-.665,2.615-3.1l1.727.621c-1.151,3.811-3.012,5.1-5.361,5.1a3.622,3.622,0,0,1-3.989-3.857m3.722-21.357a2.573,2.573,0,0,1,2.571-2.571,2.57,2.57,0,0,1,0,5.141,2.572,2.572,0,0,1-2.571-2.57",
    transform: "translate(-13.55 -13.245)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M69.131,66.047H65.809l.842-3.279H72.5l2.215,15.2c3.411-3.678,5.894-7.444,6.646-10.368a2.653,2.653,0,0,1,.8-5.185c1.683,0,2.923,1.285,2.923,3.412,0,4.033-4.163,10.414-10.368,16.573H72.188Z",
    transform: "translate(-16.884 -16.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M94.563,75.551a9.1,9.1,0,0,1,.309-2.081l2.659-10.192H93.944L94.783,60h7.489L98.728,73.514a7.59,7.59,0,0,0-.31,1.95c0,.842.443,1.33,1.153,1.33.885,0,1.682-.665,2.613-3.1l1.728.621c-1.152,3.811-3.012,5.1-5.362,5.1a3.622,3.622,0,0,1-3.987-3.857m3.722-21.357a2.573,2.573,0,0,1,2.569-2.571,2.57,2.57,0,1,1,0,5.141,2.573,2.573,0,0,1-2.569-2.57",
    transform: "translate(-24.103 -13.245)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M120.7,78.38a9.89,9.89,0,0,1,.312-2.171l1.639-5.759a6.586,6.586,0,0,0,.311-1.951,2.676,2.676,0,0,0-2.881-2.791c-2.349,0-4.563,1.994-5.539,5.8l-2.57,10.368h-3.9l3.989-15.819h-3.545l.842-3.279h6.825l-1.02,4.475c1.506-2.659,3.988-4.785,6.6-4.785a5.016,5.016,0,0,1,5.184,5.407,11.806,11.806,0,0,1-.488,3.1l-1.639,5.627a8.616,8.616,0,0,0-.266,1.552c0,.887.444,1.418,1.2,1.418s1.6-.665,2.481-3.1l1.729.62c-1.019,3.456-2.835,5.1-5.185,5.1-2.614,0-4.077-1.6-4.077-3.812",
    transform: "translate(-27.726 -16.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M136.833,88.512a3.188,3.188,0,0,1-1.108-2.48,2.449,2.449,0,0,1,2.437-2.615,2.346,2.346,0,0,1,2.349,2.394,2.463,2.463,0,0,1-.266,1.152,6.513,6.513,0,0,0,3.19.709,5.475,5.475,0,0,0,4.209-1.6,9.128,9.128,0,0,0,2.128-4.609l.842-3.589a8.136,8.136,0,0,1-6.558,3.767c-4.3,0-6.958-3.058-6.958-7.666,0-6.2,4.3-11.566,10.1-11.566a6.051,6.051,0,0,1,5.893,4.342l1.2-4.076h3.589l-4.564,19.674a11.8,11.8,0,0,1-2.791,5.938c-1.684,1.641-3.9,2.437-7,2.437-2.658,0-5.538-1.063-6.69-2.216M152.3,70.389a4.293,4.293,0,0,0-4.609-4.565c-3.722,0-6.557,3.546-6.557,7.888a4.3,4.3,0,0,0,4.519,4.608c3.812,0,6.647-3.81,6.647-7.931",
    transform: "translate(-34.822 -16.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M54.947,97.756H51.8l.841-3.589H63.367l-.8,3.589H58.892l.885,18.344L70.589,97.358H72.5l3.234,18.83,8.952-18.432H81.136l.8-3.589H92.7l-.842,3.589H89.067L75.818,123.634H73.646l-3.5-18.567L58.936,123.634l-2.128.045Z",
    transform: "translate(-13.291 -24.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M96.209,119.406c0-6.514,4.519-12.186,10.058-12.186a6,6,0,0,1,5.717,4.519l1.24-4.254h3.632l-3.366,13.6a8.25,8.25,0,0,0-.355,1.95c0,.842.4,1.329,1.151,1.329.71,0,1.6-.663,2.482-3.1l1.729.622c-1.153,3.81-3.147,5.1-5.273,5.1a3.537,3.537,0,0,1-3.678-3.855V122.9c-1.64,2.261-3.944,4.122-6.825,4.122-3.812,0-6.512-2.969-6.512-7.622m14.887-4.077c0-2.836-1.418-4.7-4.342-4.7-3.723,0-6.514,4.032-6.514,8.331,0,2.792,1.373,4.742,4.032,4.742,3.9,0,6.823-4.21,6.823-8.376",
    transform: "translate(-24.684 -27.509)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M126.4,133.319a3.194,3.194,0,0,1-1.108-2.482,2.451,2.451,0,0,1,2.438-2.615,2.346,2.346,0,0,1,2.348,2.393,2.445,2.445,0,0,1-.266,1.154,6.519,6.519,0,0,0,3.191.708,5.479,5.479,0,0,0,4.21-1.6,9.137,9.137,0,0,0,2.127-4.608l.842-3.59a8.134,8.134,0,0,1-6.558,3.768c-4.3,0-6.957-3.058-6.957-7.666,0-6.2,4.3-11.565,10.1-11.565a6.05,6.05,0,0,1,5.893,4.343l1.2-4.078h3.589l-4.565,19.674a11.8,11.8,0,0,1-2.792,5.938c-1.684,1.639-3.9,2.437-7,2.437-2.657,0-5.538-1.062-6.69-2.215M141.868,115.2a4.294,4.294,0,0,0-4.609-4.566c-3.723,0-6.559,3.545-6.559,7.889a4.3,4.3,0,0,0,4.52,4.609c3.811,0,6.648-3.811,6.648-7.932",
    transform: "translate(-32.146 -27.509)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M158.848,118.343v.662c0,2.882,2.3,4.787,5.759,4.787a12.545,12.545,0,0,0,6.294-1.728l-.754,3.632a12.866,12.866,0,0,1-6.337,1.331c-4.564,0-8.773-2.882-8.773-8.111,0-6.469,4.785-11.7,10.457-11.7,4.653,0,7.712,2.659,7.712,7.133a12.64,12.64,0,0,1-.711,3.99Zm.532-2.792h9.926a5.327,5.327,0,0,0,.266-1.641c0-1.994-1.331-3.455-4.078-3.455s-5.1,2.082-6.114,5.1",
    transform: "translate(-39.777 -27.509)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M79.94,146.342h6.643l-.645,2.816H87.4l.984-4.165H76.258l-.347,1.349h2.511l-3.409,14.742H72.8l-.347,1.35H78.83l.308-1.35H76.53l1.523-6.554h5.788l.306-1.374H78.364Z",
    transform: "translate(-18.588 -37.2)",
    fill: "#fff9f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M114.649,161.931c-.57,1.348-.958,1.619-1.4,1.619a.629.629,0,0,1-.659-.681,5.022,5.022,0,0,1,.228-1.239l2.061-8.232h-1.443l-1.259,5.077c-.72,2.9-2.608,5-4.489,5a1.512,1.512,0,0,1-1.714-1.533,6.644,6.644,0,0,1,.252-1.729l1.723-6.812h-3.535l-.314,1.3h2.114l-1.351,5.3a8.129,8.129,0,0,0-.316,1.963,2.748,2.748,0,0,0,3.012,2.78,4.766,4.766,0,0,0,3.728-2.244,3.226,3.226,0,0,0-.023.368,1.76,1.76,0,0,0,1.882,1.876c1.152,0,1.887-.716,2.537-2.47l.083-.225-1.042-.3Z",
    transform: "translate(-26.708 -39.357)",
    fill: "#fff9f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M131.619,161.882c-.567,1.419-1.006,1.615-1.394,1.615a.627.627,0,0,1-.656-.681,5.79,5.79,0,0,1,.249-1.305l1.008-3.358a7.7,7.7,0,0,0,.372-2.078,2.833,2.833,0,0,0-3.093-2.882,4.65,4.65,0,0,0-3.653,2.1l.508-1.944h-3.543l-.275,1.3h2.107l-2.48,9.893h1.416l1.256-5.075c.759-2.9,2.656-5,4.511-5a1.593,1.593,0,0,1,1.818,1.637,6.257,6.257,0,0,1-.3,1.769l-1.036,3.415a6.181,6.181,0,0,0-.265,1.531,1.8,1.8,0,0,0,1.954,1.876c1.161,0,1.918-.74,2.534-2.473l.078-.223-1.04-.3Z",
    transform: "translate(-30.985 -39.304)",
    fill: "#fff9f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M177.492,149.244l-1.526.42-.688,2.669h-1.94l-.315,1.3h1.938l-1.689,6.8a5.8,5.8,0,0,0-.188,1.29,1.951,1.951,0,0,0,2.135,1.979,5.222,5.222,0,0,0,3.083-1.442l.161-.126-.625-.958-.189.131a4.591,4.591,0,0,1-2.275,1.1.76.76,0,0,1-.836-.784,4.177,4.177,0,0,1,.148-1.033l1.716-6.959h3.384l.315-1.3h-3.383Z",
    transform: "translate(-44.392 -38.291)",
    fill: "#fff9f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "M187.956,148.06a.655.655,0,1,0,.63.656.66.66,0,0,0-.63-.656",
    transform: "translate(-48.062 -37.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    d: "M186.824,161.935c-.537,1.34-.935,1.615-1.367,1.615a.633.633,0,0,1-.682-.681,5.459,5.459,0,0,1,.251-1.284l2.3-8.186H183.6l-.275,1.3h2.225l-1.906,6.64a6.2,6.2,0,0,0-.267,1.506,1.838,1.838,0,0,0,1.98,1.9c1.144,0,1.894-.74,2.508-2.474l.078-.223-1.041-.3Z",
    transform: "translate(-47.034 -39.357)",
    fill: "#fff9f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    d: "M187.8,147.46a1.1,1.1,0,1,0,1.076,1.1,1.1,1.1,0,0,0-1.076-1.1m0,1.755a.655.655,0,1,1,.63-.653.658.658,0,0,1-.63.653",
    transform: "translate(-47.908 -37.833)",
    fill: "#fff9f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M94.861,153.156c-3.655,0-6.111,3.454-6.111,6.68a4.6,4.6,0,0,0,4.742,4.872c3.313,0,6.112-3.059,6.112-6.68a4.6,4.6,0,0,0-4.742-4.872m-1.318,10.253a3.288,3.288,0,0,1-3.365-3.573c0-2.917,2.12-5.382,4.631-5.382a3.29,3.29,0,0,1,3.368,3.574c0,2.916-2.123,5.381-4.634,5.381",
    transform: "translate(-22.77 -39.294)",
    fill: "#fff9f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "M149.024,159.776c-.538,1.34-.936,1.615-1.369,1.615a.614.614,0,0,1-.653-.681,7.183,7.183,0,0,1,.227-1.319l3.36-14.407H147l-.274,1.3h2.112l-1.646,7.138a3.9,3.9,0,0,0-3.773-2.36c-3.2,0-5.8,3.079-5.8,6.862,0,2.85,1.668,4.69,4.252,4.69a4.882,4.882,0,0,0,3.78-1.909v.008a1.807,1.807,0,0,0,1.9,1.876c1.172,0,1.923-.74,2.509-2.477l.075-.221-1.038-.3Zm-7,1.538c-1.85,0-2.955-1.278-2.955-3.419,0-2.663,1.694-5.537,4.427-5.537a3.041,3.041,0,0,1,3.109,3.367c0,2.638-1.96,5.589-4.581,5.589",
    transform: "translate(-35.308 -37.198)",
    fill: "#fff9f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "M166.42,161.869c-.566,1.348-.953,1.619-1.394,1.619a.627.627,0,0,1-.656-.681,6.41,6.41,0,0,1,.2-1.1l2.061-8.417h-1.413l-.558,2.253a3.733,3.733,0,0,0-3.634-2.383c-3.241,0-5.878,3.136-5.878,6.99,0,2.772,1.607,4.563,4.1,4.563a5,5,0,0,0,3.782-1.887v.036a1.784,1.784,0,0,0,1.9,1.824c1.16,0,1.887-.717,2.508-2.473l.077-.22-1.01-.306Zm-7,1.542c-1.769,0-2.824-1.24-2.824-3.316,0-2.723,1.789-5.64,4.451-5.64,1.81,0,2.98,1.282,2.98,3.264,0,2.377-1.752,5.692-4.607,5.692",
    transform: "translate(-39.805 -39.294)",
    fill: "#fff9f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M196.871,153.156c-3.657,0-6.114,3.454-6.114,6.68a4.6,4.6,0,0,0,4.744,4.872c3.313,0,6.112-3.059,6.112-6.68a4.6,4.6,0,0,0-4.742-4.872m-1.318,10.253a3.29,3.29,0,0,1-3.368-3.573c0-2.917,2.121-5.382,4.632-5.382a3.29,3.29,0,0,1,3.368,3.574c0,2.916-2.121,5.381-4.632,5.381",
    transform: "translate(-48.942 -39.294)",
    fill: "#fff9f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "M216.851,161.694l-.075.188c-.568,1.419-1.006,1.615-1.395,1.615a.626.626,0,0,1-.654-.681,5.841,5.841,0,0,1,.248-1.305l1.007-3.358a7.676,7.676,0,0,0,.37-2.079,2.832,2.832,0,0,0-3.09-2.882,4.653,4.653,0,0,0-3.655,2.1l.508-1.945h-3.542l-.276,1.3h2.108l-2.481,9.894h1.416l1.255-5.075c.761-2.9,2.658-5,4.511-5a1.594,1.594,0,0,1,1.818,1.637,6.246,6.246,0,0,1-.3,1.769l-1.036,3.415a6.173,6.173,0,0,0-.265,1.531,1.8,1.8,0,0,0,1.954,1.876c1.16,0,1.919-.74,2.534-2.473l.08-.223Z",
    transform: "translate(-52.833 -39.304)",
    fill: "#fff9f0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivingWageFoundationLogo);
export default __webpack_public_path__ + "static/media/Living_Wage_Foundation_logo.078e63b6f0042fb259089cb70f0be557.svg";
export { ForwardRef as ReactComponent };